export default __webpack_public_path__ + "static/media/surveyIcon.4482762e.svg";